import { UrlConstants } from "../url.constants";
export class ApiAvailableSurveyConstants {
    static URL = UrlConstants.API_V2 + "AvailableSurvey";
    static FUNCTION_DELETE_MULTIPLE_SURVEY_123S = "DeleteMultipleSurvey123s";
    static FUNCTION_GET_LOCATION_DATA = "GetLocationData";
    static FUNCTION_DELETE_ALL_SURVEY_123S = "DeleteAllSurvey123s";
}
